import React from 'react';
import { REACT_APP_API_ENDPOINT_DOCUMENT_TYPE } from '../../../Domain/Settings/SettingsVariables';
import { Get } from '../../HTTP/Get';

//Feature: ApiDocumentType
//Autor: Sthewar.Rojano
//Description: Call of backend with the final purpose get document type
function ApiDocumentType() {
    const { AxiosGet } = Get()

    if (!localStorage.hasOwnProperty('TypeDoc')) {
    AxiosGet(`${ REACT_APP_API_ENDPOINT_DOCUMENT_TYPE }`)
        .then(response => {
            localStorage.setItem('TypeDoc',JSON.stringify(response.data))
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }
}

export default ApiDocumentType;